/** Выбор языка — подключение к стору и колбэкам. */
import type { WindowProps } from "../kit";
import { LanguageView } from "./view";
import { appStore, useStore, registerWindow } from "../../../app";
import { actions } from "../actions";

declare module "../../../app/state/window-route" {
  interface WindowRoutes {
    language: object;
  }
}

export function Language({ close }: WindowProps<"language">) {
  const current = useStore(appStore, (s) => s.locale);
  return (
    <LanguageView
      current={current}
      onPick={(locale) => {
        actions().changeLocale(locale);
        close();
      }}
      onClose={close}
    />
  );
}

export function register(): void {
  registerWindow("language", Language);
}
